var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"billing-premium-label"},[_c('e-svg-icon',{attrs:{"name":"lightning-primary","size":"sm"}}),_c('span',{staticClass:"fw-500 color-primary",class:[_vm.xsDevice ? 'text-12px' : 'text-14px']},[_vm._v("Premium")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }